import { render } from "./accountReport.vue?vue&type=template&id=05054db0"
import script from "./accountReport.vue?vue&type=script&lang=js"
export * from "./accountReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__